import React, { useEffect } from "react";
import { ModalCard } from "@dishopsaas/design-system";
import SignInSignUpContainer from "../SignInSignUpContainer";
import { useSignInSignUp } from "../../hooks/useSignInSignUp";
import getStyles from "./ConnexionModal.styles";
import { Box } from "@mui/material";
import CloseButton from "../CloseButton";
import { getColors } from '../../utils'
const ConnexionModal: React.FC = () => {
  const {
    connexionModal,
    userConnected,
    handleCloseConnexionModal,
    handleUserConnected,
    signUp,
  } = useSignInSignUp();
  const colors = getColors();
  const styles = getStyles()
  useEffect(() => {
    if (userConnected) {
      handleUserConnected();
    }
  }, [userConnected, handleUserConnected]);

  return (
    <ModalCard
      open={connexionModal}
      sxModal={{
        ...styles.container,
        background: colors.bgwhite,
        ...(signUp && { maxWidth: "440px" }),
      }}
      onClose={handleCloseConnexionModal}
    >
      <Box>
        <CloseButton
          sx={styles.close}
          onClick={handleCloseConnexionModal}
        ></CloseButton>
        <SignInSignUpContainer />
      </Box>
    </ModalCard>
  );
};

export default ConnexionModal;
